import { createSelector } from "@reduxjs/toolkit"
import { FormRootState } from "./formStore"
import { selectForm } from "./selectForm"
import _ from 'lodash'
import { useFormSelector } from "./formStoreHooks"
import { sortedPrescriptionModels } from "@fusion-advantage/formlib"

export const selectAllIcd10s = createSelector(
	(state: FormRootState) => state.formModel.claimHistory,
	(state: FormRootState) => selectForm(state).concepts,
	(claimHistory, concepts) => {
		let supportedIcd10s: string[] = []
		_.forEach(concepts, concept => {
			if(concept.isDx && concept.icd10) {
				supportedIcd10s.push(concept.icd10)
			}
		})
		let priorIcd10s: string[] = claimHistory.map(diagnosis => diagnosis.DiagnosisCode)
		return ({
			supportedIcd10s,
			priorIcd10s
		})
	},
)

export const selectModelById = (state: FormRootState, productId: number|null) =>
	state.drug.models.find(m => m.Product.ID === productId)

export const useModelById = (productId: number|null) =>
	useFormSelector(state => selectModelById(state, productId))

export const selectMedReconSorted = createSelector(
	(state: FormRootState) => state.drug.models,
	(models) => sortedPrescriptionModels(models)
)
